import React, {FC} from "react";
import {Provider} from "react-redux";
import store from "@fkhplus/common/src/modules/store";

const StateProvider: FC = ({children}) => {
    return (
        <Provider store={store}>{children}</Provider>
    )
};
export default StateProvider;